/**
 * @fileoverview Score handling - GameState統合版
 */

import gameState from '../core/game-state.js';
import { STATE_PATHS } from '../shared/constants/state-paths.js';

// セッション統計（モジュール変数）
let sessionMaxChain = 0;
let sessionMaxMatch = 0;

export function updateScore(matches, chain) {
  const numberOfPieces = matches.length;
  const scoreToAdd = numberOfPieces ** 2 * chain ** 4;

  // スコア更新
  const currentScore = gameState.getState(STATE_PATHS.GAME_SCORE) || 0;
  const newScore = currentScore + scoreToAdd;
  gameState.setState(STATE_PATHS.GAME_SCORE, newScore, 'matchScore');

  // セッション統計を更新
  if (chain > sessionMaxChain) sessionMaxChain = chain;
  if (numberOfPieces > sessionMaxMatch) sessionMaxMatch = numberOfPieces;

  return newScore;
}

export function resetScore() {
  gameState.setState(STATE_PATHS.GAME_SCORE, 0, 'gameReset');
  sessionMaxChain = 0;
  sessionMaxMatch = 0;
  return 0;
}

export function getScore() {
  return gameState.getState(STATE_PATHS.GAME_SCORE) || 0;
}

/**
 * 現在のセッションの統計を取得
 * @returns {{maxChain: number, maxMatch: number}}
 */
export function getSessionStats() {
  return {
    maxChain: sessionMaxChain,
    maxMatch: sessionMaxMatch,
  };
}
